import React, { useContext } from "react";

import useHttp from "../../../../hooks/useHttp";
import {
  OFFER_WITHDRAW_URL,
  OFFER_RE_ACTIVE_URL,
} from "../../../../utils/api-ends";
import { ManageLoadPostDetailPageContext } from "../";
import LoaderImg from "../../../../assets/media/loader.gif";

const CarrierSpeficificLoadPostOfferInfo = ({
  isLoadingCarrierActivity,
  offer,
}) => {
  const { isLoading, sendRequests: withdrawRequest } = useHttp();
  const { isLoading: isLoadingReactivate, sendRequests: reactivateRequests } =
    useHttp();
  const [loadPostDetailState, loadPostDetailContextDispatch] = useContext(
    ManageLoadPostDetailPageContext
  );

  const handleWithdraw = (offerId) => {
    const response = (data) => {
      loadPostDetailContextDispatch({
        type: "CARRIER_WITHDRAW_OFFER",
        payload: {
          data: offer,
        },
      });
    };
    withdrawRequest(
      {
        url: OFFER_WITHDRAW_URL(offerId),
        method: "patch",
      },
      response
    );
  };

  const handleReactivate = (offerId) => {
    const response = (data) => {
      loadPostDetailContextDispatch({
        type: "CARRIER_REACTIVE_OFFER",
        payload: {
          data: offer,
        },
      });
    };
    reactivateRequests(
      {
        url: OFFER_RE_ACTIVE_URL(offerId),
        method: "patch",
      },
      response
    );
  };

  return (
    <section>
      <div className="container theme-section">
        <h1 className="large-text text-center mb-4">Sent Offer</h1>

        {isLoadingCarrierActivity ? (
          <div className="d-flex justify-content-center">
            <img src={LoaderImg} alt="" style={{ width: "40px" }} />
          </div>
        ) : offer.is_already_send_offer === true ? (
          <div className="carrier-offer-table-wrapper">
            <div className="carrier-offer-table">
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">Status</th>
                    <th scope="col">Offer Amount </th>
                    <th scope="col">Counter Offer</th>
                    <th scope="col">Counter Offer Status</th>
                    <th scope="col">Fixed Offer</th>
                    <th scope="col">Pickup Datetime</th>
                    <th scope="col">
                      Estimated Duration <br /> Of Delivery
                    </th>
                    <th scope="col">Description</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td>{offer.status_value}</td>
                    <td>${offer.amount}</td>
                    <td>
                      {!["", null, undefined].includes(offer?.counter_amount)
                        ? `$${offer?.counter_amount}`
                        : "- - -"}
                    </td>
                    <td>
                      {!["", null, undefined].includes(
                        offer?.counter_status_display
                      )
                        ? offer?.counter_status_display
                        : "- - -"}
                    </td>
                    <td>
                      {offer?.is_counter_amount_fixed === true ? (
                        <i className="fa-solid fa-check"></i>
                      ) : (
                        <i className="fa-solid fa-xmark"></i>
                      )}
                    </td>
                    <td>{offer.pickup_time_formate}</td>
                    <td>{offer.estimated_delivery_time}</td>
                    <td>{offer.description}</td>
                    <td>
                      {offer?.can_withdraw === true && (
                        <button onClick={() => handleWithdraw(offer.id)}>
                          Withdraw
                          {isLoading && (
                            <img
                              style={{
                                width: "22px",
                                marginLeft: "8px",
                              }}
                              src={LoaderImg}
                              alt="Loader"
                            />
                          )}
                        </button>
                      )}

                      {offer?.can_reactive === true && (
                        <button onClick={() => handleReactivate(offer.id)}>
                          Re-Activate
                          {isLoadingReactivate && (
                            <img
                              style={{
                                width: "22px",
                                marginLeft: "8px",
                              }}
                              src={LoaderImg}
                              alt="Loader"
                            />
                          )}
                        </button>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <p className="text-center">No offer send yet</p>
        )}
      </div>
    </section>
  );
};

export default CarrierSpeficificLoadPostOfferInfo;
